import {
    Modal, Button, ModalHeader, ModalBody, ModalFooter, Badge,
} from 'appkit-react';

import '../styles/tenantWarningModal.scss';

const TenantWarningModal = ({
    showWarningModal, setShowWarningModal, setConfirmDelete,
}) => (
    <div className="true-comply-tenant_warning_modal">
        <Modal
            className="action-modal-showcase"
            visible={showWarningModal}
            onCancel={() => setShowWarningModal(false)}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <Badge className="example-badge" type="warning">WARNING</Badge>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <div
                    className="true-comply-tenant_warning_modal_description a-apply-theme-font-default-white"
                >
                    This action will disable all the users under this Tenant and users will not be able to login.  Are you sure you want to proceed ?
                </div>
            </ModalBody>
            <ModalFooter className="a-apply-theme-border-top-gray-level-6">
                <div className="button-comp">
                    <Button
                        kind="transparent"
                        gray
                        onClick={
                            () => {
                                setConfirmDelete(false);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        NO
                    </Button>
                    <Button
                        kind="transparent"
                        onClick={
                            () => {
                                setConfirmDelete(true);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        YES
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    </div>
);

export default TenantWarningModal;
